import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AOEvent } from 'src/app/services/yeti-protocol/event';
import { EventsService } from 'src/app/services/events/events.service';
import { AOEventParticipantType, AOEventParticipantsSuccessResponse, Participant } from '../../services/yeti-protocol/event';
import { AppNavController } from '../../services/app-nav-controller.service';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { MIComponentsModule } from '../components.module';
import { UsersModule } from 'src/app/modules/users/users.module';

@Component({
  selector: 'app-event-info-card',
  templateUrl: './event-info-card.component.html',
  styleUrls: ['./event-info-card.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IonicModule,
    MIComponentsModule,
    UsersModule
  ]
})
export class EventInfoCardComponent implements OnChanges {

  @Input() event: AOEvent;

  eventParticipants: Array<Participant>;
  totalEventParticipants: number;

  constructor(
    private eventsService: EventsService,
    private appNavController: AppNavController
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes?.event &&
      changes?.event?.currentValue &&
      changes?.event?.currentValue?._id !== changes?.event?.previousValue?._id) {
      this.fetchEventParticipants();
    }
  }

  get eventType(): string {

    if (this.event?.eventType?.length > 1) {
      const type = this.event?.eventType?.toLowerCase();
      return type.charAt(0).toUpperCase() + type.slice(1)
    } else {
      return '';
    }
  }

  fetchEventParticipants(): void {
    this.eventsService.getAOEventParticipants(this.event?._id, AOEventParticipantType.PARTICIPANT, 0, 6)
      .then((aoEventParticipantsRes: AOEventParticipantsSuccessResponse) => {
        this.eventParticipants = aoEventParticipantsRes.result.map(res => res.participantInfo);
        this.totalEventParticipants = aoEventParticipantsRes.totalItemsCount;
      }).catch(err => {
        console.error(err);
      });
  }

  openEvent(): void {
    this.appNavController.openEvent(this.event?._id);
  }

}
